// Code generated by missionstream_tsgen.go; DO NOT EDIT.
// The mission stream's browser shapes, delivery states, receipt tables, forced reasons, text cap, request-id prefixes and HITL modalities, from the Go package platform/shared/contract/missionstream.
// Regenerate: cd platform/shared && go test ./contract/missionstream -run TestGeneratedTypeScriptIsCurrent -update
// Body SHA-256: 05fc85b9cdd73926a86d6b32d748dac291fe8eaa414ffa7766b125efd7e669ee

/** The message type of ConnectionRestoredView. */
export const MessageTypeConnectionRestored = 'mission.connection_restored'

/** The message type of Delegation. */
export const MessageTypeDelegation = 'mission.delegation'

/** The message type of EscalationAnswerFrame. */
export const MessageTypeEscalationAnswerFrame = 'mission.escalation.answer'

/** The message type of EscalationAnswerResult. */
export const MessageTypeEscalationAnswerResult = 'mission.escalation.answer.result'

/** The message type of GovernanceDecision. */
export const MessageTypeGovernanceDecision = 'mission.governance.decision'

/** The message type of HITLResponse. */
export const MessageTypeHITLResponse = 'mission.hitl.response'

/** The message type of OperatorEndUserTurnEvent. */
export const MessageTypeOperatorEndUserTurnEvent = 'mission.operator.end_user_turn'

/** The message type of OperatorHoldEvent. */
export const MessageTypeOperatorHoldEvent = 'mission.operator.hold'

/** The message type of OperatorMessageView. */
export const MessageTypeOperatorMessage = 'mission.operator.message'

/** The message type of OperatorMessageReceipt. */
export const MessageTypeOperatorMessageReceipt = 'mission.operator.message.receipt'

/** The message type of OperatorTurnEvent. */
export const MessageTypeOperatorTurnEvent = 'mission.operator.turn'

/** The message type of QuestionAnswerResult. */
export const MessageTypeQuestionAnswerResult = 'mission.question.answer.result'

/** The message type of QuestionClosed. */
export const MessageTypeQuestionClosed = 'mission.question.closed'

/** The message type of ToolCallView. */
export const MessageTypeToolCall = 'mission.tool.call'

/** The message type of ToolResultView. */
export const MessageTypeToolResult = 'mission.tool.result'

/** The message type of MissionTrigger. */
export const MessageTypeMissionTrigger = 'mission.trigger'

/** The message type of UserMessageView. */
export const MessageTypeUserMessage = 'mission.user.message'

/** The message type of UserMessageQueuedView. */
export const MessageTypeUserMessageQueued = 'mission.user.message.queued'

/** The message type of UserMessageReceiptView. */
export const MessageTypeUserMessageReceipt = 'mission.user.message.receipt'

/** The browser's shape of each frame, per message type: a view, or a frame the relay forwards as the host sent it. */
export interface MissionStreamViews {
  'mission.connection_restored': ConnectionRestoredView
  'mission.delegation': Delegation
  'mission.escalation.answer': EscalationAnswerFrame
  'mission.escalation.answer.result': EscalationAnswerResult
  'mission.governance.decision': GovernanceDecision
  'mission.hitl.response': HITLResponse
  'mission.operator.end_user_turn': OperatorEndUserTurnEvent
  'mission.operator.hold': OperatorHoldEvent
  'mission.operator.message': OperatorMessageView
  'mission.operator.message.receipt': OperatorMessageReceipt
  'mission.operator.turn': OperatorTurnEvent
  'mission.question.answer.result': QuestionAnswerResult
  'mission.question.closed': QuestionClosed
  'mission.tool.call': ToolCallView
  'mission.tool.result': ToolResultView
  'mission.trigger': MissionTrigger
  'mission.user.message': UserMessageView
  'mission.user.message.queued': UserMessageQueuedView
  'mission.user.message.receipt': UserMessageReceiptView
}

/** A message type whose browser payload is generated. */
export type MissionStreamMessageType = keyof MissionStreamViews

/** Go: missionstream.ConnectionRestoredView. */
export interface ConnectionRestoredView {
  mission_id: string
  execution_id: string
  host_id: string
}

/** Go: missionstream.Delegation. */
export interface Delegation {
  mission_id: string
  execution_id?: string
  delegation_id: string
  agent_node_id: string
  agent_label: string
  task: string
  context?: string
  constraints?: string
  depth: number
}

/** Go: missionstream.EscalationAnswerFrame. */
export interface EscalationAnswerFrame {
  escalation_id: string
  ticket: string
  answer: QuestionReply
}

/** Go: missionstream.EscalationAnswerResult. */
export interface EscalationAnswerResult {
  escalation_id: string
  outcome: string
  reason?: string
}

/** Go: missionstream.GovernanceDecision. */
export interface GovernanceDecision {
  mission_id: string
  execution_id?: string
  node_id: string
  agent_id?: string
  action: string
  reason?: string
  rule_name?: string
  trust_tier?: string
}

/** Go: missionstream.HITLResponse. */
export interface HITLResponse {
  mission_id: string
  execution_id?: string
  node_id: string
  request_id: string
  response: string
  response_time_ms: number
  attachments?: UserMessageAttachment[]
  decision?: string
  user_id?: string
  user_name?: string
  answer_attempt_id?: string
  answer?: QuestionReply
}

/** Go: missionstream.OperatorEndUserTurnEvent. */
export interface OperatorEndUserTurnEvent {
  mission_id: string
  execution_id: string
  hold_id: string
  message_id: string
  sender_user_id: string
  text: string
  created_at: string
}

/** Go: missionstream.OperatorHoldEvent. */
export interface OperatorHoldEvent {
  mission_id: string
  execution_id: string
  hold_id: string
  state: string
  operator_display_name?: string
  notice_key: string
  notice_text: string
  locale: string
  at: string
}

/** Go: missionstream.OperatorMessageView. */
export interface OperatorMessageView {
  message_id: string
  mission_id: string
  execution_id: string
  hold_id: string
  text: string
}

/** Go: missionstream.OperatorMessageReceipt. */
export interface OperatorMessageReceipt {
  message_id: string
  execution_id: string
  hold_id?: string
  status: string
  reason?: string
}

/** Go: missionstream.OperatorTurnEvent. */
export interface OperatorTurnEvent {
  mission_id: string
  execution_id: string
  hold_id: string
  message_id: string
  operator_user_id: string
  operator_display_name: string
  text: string
  created_at: string
}

/** Go: missionstream.QuestionAnswerResult. */
export interface QuestionAnswerResult {
  answer: HITLResponse
  outcome: QuestionAnswerOutcome
  reason?: QuestionAnswerReason
  state_version?: QuestionStateVersion
}

/** Go: missionstream.QuestionClosed. */
export interface QuestionClosed {
  mission_id: string
  execution_id: string
  request_id: string
  reason: QuestionClosedReason
  state_version?: QuestionStateVersion
}

/** Go: missionstream.ToolCallView. */
export interface ToolCallView {
  mission_id: string
  execution_id?: string
  node_id: string
  agent_id: string
  agent_label?: string
  tool_call_id: string
  tool_name: string
  tool_input?: Record<string, unknown>
  resource_id?: string
}

/** Go: missionstream.ToolResultView. */
export interface ToolResultView {
  mission_id: string
  execution_id?: string
  node_id: string
  agent_id: string
  agent_label?: string
  tool_call_id: string
  tool_name: string
  success: boolean
  output?: unknown
  error?: string
  duration_ms: number
  denied_by_guard?: boolean
  resource_id?: string
  output_files?: OutputFile[]
  output_files_total?: number
  output_files_truncated?: boolean
}

/** Go: missionstream.MissionTrigger. */
export interface MissionTrigger {
  parent_mission_id: string
  parent_node_id: string
  mission_id: string
  execution_id: string
  input?: Record<string, unknown>
}

/** Go: missionstream.UserMessageView. */
export interface UserMessageView {
  message_id: string
  mission_id: string
  execution_id: string
  text: string
  attachments?: UserMessageAttachment[]
}

/** Go: missionstream.UserMessageQueuedView. */
export interface UserMessageQueuedView {
  mission_id: string
  execution_id: string
  messages: UserMessageQueuedEntry[] | null
}

/** Go: missionstream.UserMessageReceiptView. */
export interface UserMessageReceiptView {
  message_id?: string
  mission_id: string
  execution_id: string
  outcome: ReceiptOutcome
  reason?: ReceiptReason
}

/** Go: missionstream.HITLRequest. */
export interface HITLRequest {
  mission_id: string
  execution_id?: string
  node_id: string
  agent_id?: string
  agent_label?: string
  request_id: string
  modality: string
  prompt: string
  options?: string[]
  option_details?: HITLOptionDetail[]
  continuation?: boolean
  timeout_ms?: number
  kind?: string
  governance_context?: GovernanceContext
  answer_for_delegation_id?: string
  question?: Question
}

/** Go: missionstream.QuestionStateVersion. */
export interface QuestionStateVersion {
  incarnation_id: string
  revision: string
}

/** Go: missionstream.QuestionStateQuery. */
export interface QuestionStateQuery {
  query_id: string
  mission_id: string
  execution_id: string
  request_id?: string
  answer_attempt_id?: string
}

/** Go: missionstream.QuestionStateRequest. */
export interface QuestionStateRequest {
  query: QuestionStateQuery
  sender_user_id: string
  sender_organization_id: string
}

/** Go: missionstream.QuestionStateSnapshot. */
export interface QuestionStateSnapshot {
  mission_id: string
  execution_id: string
  query_id?: string
  outcome: QuestionStateOutcome
  state_version?: QuestionStateVersion
  questions?: HITLRequest[] | null
  answer_result?: QuestionAnswerResult
  reason?: QuestionAnswerReason
}

/** Go: missionstream.QuestionReply. */
export interface QuestionReply {
  selected_option_ids?: string[]
  text?: string
  form_values?: Record<string, unknown> | null
  question_id?: string
  other_text?: string
  decision?: string
  reason?: string
  responder?: QuestionResponder
  input?: QuestionInput
  answered_at?: string
}

/** Go: missionstream.UserMessageAttachment. */
export interface UserMessageAttachment {
  host_file_id: string
  host_id?: string
  filename: string
  content_type: string
  size: number
}

/** Go: missionstream.OutputFile. */
export interface OutputFile {
  name: string
  file_id: string
  size: number
  content_type: string
  download_url: string
  host_id?: string
  execution_id?: string
  organization_id?: string
  mission_id?: string
  sha256?: string
}

/** Go: missionstream.UserMessageQueuedEntry. */
export interface UserMessageQueuedEntry {
  message_id: string
  text: string
  attachments?: UserMessageAttachment[]
}

/** Go: missionstream.HITLOptionDetail. */
export interface HITLOptionDetail {
  id: string
  label: string
  description: string
}

/** Go: missionstream.GovernanceContext. */
export interface GovernanceContext {
  rule_name: string
  severity: string
  node_id?: string
  action?: string
  escalation_id?: string
  inline_decision?: boolean
  question_card?: boolean
}

/** Go: missionstream.Question. */
export interface Question {
  type: string
  text: string
  locale: string
  options?: QuestionOption[]
  selection?: QuestionSelection
  max_length?: number
  fields?: QuestionFormField[]
  expires_at: string
  addressee: QuestionAddressee
  asker: QuestionAsker
  required?: boolean
  other?: QuestionOther
  approval?: QuestionApproval
  on_expiry?: string
  on_undeliverable?: string[]
}

/** Go: missionstream.QuestionResponder. */
export interface QuestionResponder {
  subject_kind: string
  subject_ref: string
  channel?: string
  conversation_ref?: string
}

/** Go: missionstream.QuestionInput. */
export interface QuestionInput {
  method: string
  provider_message_id?: string
  raw_hmac?: string
  reprompts?: number
}

/** Go: missionstream.QuestionOption. */
export interface QuestionOption {
  id: string
  label: string
  short_label?: string
  description?: string
}

/** Go: missionstream.QuestionSelection. */
export interface QuestionSelection {
  min: number
  max: number
}

/** Go: missionstream.QuestionFormField. */
export interface QuestionFormField {
  id: string
  kind: string
  label: string
  description?: string
  required: boolean | null
  max_length?: number
  min?: number
  max?: number
}

/** Go: missionstream.QuestionAddressee. */
export interface QuestionAddressee {
  subject_kind: string
  subject_ref: string
  channel_binding?: string
  conversation_ref?: string
}

/** Go: missionstream.QuestionAsker. */
export interface QuestionAsker {
  mission_id: string
  execution_id: string
  node_id: string
  agent_id?: string
  agent_label?: string
}

/** Go: missionstream.QuestionOther. */
export interface QuestionOther {
  allowed: boolean
  label?: string
  max_length?: number
}

/** Go: missionstream.QuestionApproval. */
export interface QuestionApproval {
  consequence: string
  reason_required?: boolean
  reason_min_length?: number
}

/** A user send's delivery state (Go: missionstream.DeliveryState). */
export type DeliveryState = 'waiting' | 'sending' | 'queued' | 'delivered' | 'failed' | 'refused'

/** One row of the delivery-state table: a state and what it means. */
export type DeliveryStateRow = { readonly state: DeliveryState; readonly description: string }

/** Every delivery state, in the table's order (Go: missionstream.DeliveryStates). */
export const DeliveryStates: readonly DeliveryStateRow[] = [
  { state: 'waiting', description: 'Held in the browser until its attachments finish uploading; nothing has been sent.' },
  { state: 'sending', description: 'Sent from the browser; no receipt has arrived yet.' },
  { state: 'queued', description: 'The run accepted it while the agent works; the agent gets it at its next turn.' },
  { state: 'delivered', description: 'A receipt confirmed it was passed on to the run.' },
  { state: 'failed', description: 'Not sent, or no receipt arrived in time; it goes back to the composer.' },
  { state: 'refused', description: 'The relay refused it with a reason; it goes back to the composer.' },
]

/** question answer outcome (Go: missionstream.QuestionAnswerOutcome). */
export type QuestionAnswerOutcome = 'accepted' | 'refused' | 'unknown'

/** question answer outcome */
export type QuestionAnswerOutcomeRow = { readonly value: QuestionAnswerOutcome; readonly description: string }

/** question answer outcome (Go: missionstream.QuestionAnswerOutcomes). */
export const QuestionAnswerOutcomes: readonly QuestionAnswerOutcomeRow[] = [
  { value: 'accepted', description: 'The host handed the answer to its exact waiter.' },
  { value: 'refused', description: 'The host refused this attempt; the question may still be open.' },
  { value: 'unknown', description: 'The host cannot confirm this attempt and did not hand it off again.' },
]

/** question answer reason (Go: missionstream.QuestionAnswerReason). */
export type QuestionAnswerReason = 'answer_in_progress' | 'answer_admission_unavailable' | 'invalid_answer' | 'attempt_conflict' | 'question_closed' | 'confirmation_unavailable' | 'sender_not_allowed' | 'run_not_live' | 'attachment_invalid' | 'attachment_host_mismatch' | 'attachment_host_ambiguous' | 'attachment_too_many' | 'attachment_unavailable'

/** question answer reason */
export type QuestionAnswerReasonRow = { readonly value: QuestionAnswerReason; readonly description: string }

/** question answer reason (Go: missionstream.QuestionAnswerReasons). */
export const QuestionAnswerReasons: readonly QuestionAnswerReasonRow[] = [
  { value: 'answer_in_progress', description: 'Another attempt is still being admitted for this question.' },
  { value: 'answer_admission_unavailable', description: 'The host could not reserve or complete answer admission in time.' },
  { value: 'invalid_answer', description: 'The answer is not valid.' },
  { value: 'attempt_conflict', description: 'This attempt already names different answer intent.' },
  { value: 'question_closed', description: 'The exact question lease is closed.' },
  { value: 'confirmation_unavailable', description: 'Confirmation is no longer available; no new handoff occurred.' },
  { value: 'sender_not_allowed', description: 'The sender is not allowed to answer.' },
  { value: 'run_not_live', description: 'The execution is no longer live.' },
  { value: 'attachment_invalid', description: 'Attachment identity or metadata is invalid.' },
  { value: 'attachment_host_mismatch', description: 'The attachment owner differs from the execution host.' },
  { value: 'attachment_host_ambiguous', description: 'The attachment owner cannot be established.' },
  { value: 'attachment_too_many', description: 'The attachment count exceeds the server limit.' },
  { value: 'attachment_unavailable', description: 'The host could not admit every attachment.' },
]

/** question closure reason (Go: missionstream.QuestionClosedReason). */
export type QuestionClosedReason = 'cancelled' | 'expired' | 'publication_failed' | 'execution_ended'

/** question closure reason */
export type QuestionClosedReasonRow = { readonly value: QuestionClosedReason; readonly description: string }

/** question closure reason (Go: missionstream.QuestionClosedReasons). */
export const QuestionClosedReasons: readonly QuestionClosedReasonRow[] = [
  { value: 'cancelled', description: 'The waiting caller cancelled the question.' },
  { value: 'expired', description: 'The question wait expired.' },
  { value: 'publication_failed', description: 'Question publication failed.' },
  { value: 'execution_ended', description: 'The execution ended.' },
]

/** question state outcome (Go: missionstream.QuestionStateOutcome). */
export type QuestionStateOutcome = 'complete' | 'unknown'

/** question state outcome */
export type QuestionStateOutcomeRow = { readonly value: QuestionStateOutcome; readonly description: string }

/** question state outcome (Go: missionstream.QuestionStateOutcomes). */
export const QuestionStateOutcomes: readonly QuestionStateOutcomeRow[] = [
  { value: 'complete', description: 'The current owner supplied the complete open set.' },
  { value: 'unknown', description: 'The current owner cannot establish state authority.' },
]

/** A question answered by one pick (Go: missionstream.QuestionTypeSingleChoice). */
export const QuestionTypeSingleChoice = 'single_choice'

/** A question answered by several picks (Go: missionstream.QuestionTypeMultiChoice). */
export const QuestionTypeMultiChoice = 'multi_choice'

/** The reserved option id of a question's Other choice (Go: missionstream.QuestionOptionIDOther). */
export const QuestionOptionIDOther = 'other'

/** What happened to a user message, as its receipt says (Go: missionstream.ReceiptOutcome). */
export type ReceiptOutcome = 'accepted' | 'delivered' | 'refused' | 'undelivered'

/** One row of the receipt-outcome table: an outcome and what it means. */
export type ReceiptOutcomeRow = { readonly outcome: ReceiptOutcome; readonly description: string }

/** Every receipt outcome, in the table's order (Go: missionstream.ReceiptOutcomes). */
export const ReceiptOutcomes: readonly ReceiptOutcomeRow[] = [
  { outcome: 'accepted', description: 'The run on the host took the message; the agent gets it at its next turn.' },
  { outcome: 'delivered', description: 'The agent got the message as a user turn.' },
  { outcome: 'refused', description: 'The relay or the host refused the message; the reason says why.' },
  { outcome: 'undelivered', description: 'The run ended before its next turn, so the agent never got the message.' },
]

/** Why a user message was refused or not delivered (Go: missionstream.ReceiptReason). */
export type ReceiptReason = 'attachment_invalid' | 'attachment_host_mismatch' | 'attachment_host_ambiguous' | 'attachment_too_many' | 'attachment_unavailable' | 'invalid_message' | 'not_subscribed' | 'sender_not_allowed' | 'run_not_live' | 'host_not_connected' | 'runner_not_connected' | 'message_too_large' | 'channel_full' | 'inbox_full' | 'mode_does_not_accept' | 'duplicate' | 'unknown_message_type' | 'run_ended_before_delivery'

/** One row of the receipt-reason table: a reason and what it means. */
export type ReceiptReasonRow = { readonly reason: ReceiptReason; readonly description: string }

/** Every receipt reason, in the table's order (Go: missionstream.ReceiptReasons). */
export const ReceiptReasons: readonly ReceiptReasonRow[] = [
  { reason: 'attachment_invalid', description: 'The attachment references or authoritative metadata are invalid.' },
  { reason: 'attachment_host_mismatch', description: 'The attachments belong to a different host than this execution.' },
  { reason: 'attachment_host_ambiguous', description: 'The attachment host cannot be verified.' },
  { reason: 'attachment_too_many', description: 'The attachment count exceeds the server limit.' },
  { reason: 'attachment_unavailable', description: 'The host could not admit or verify every attached file before the deadline.' },
  { reason: 'invalid_message', description: 'The frame is not a well-formed user message: an id is missing or malformed, or it has no text and no attachments.' },
  { reason: 'not_subscribed', description: 'The sending connection is not subscribed to the run.' },
  { reason: 'sender_not_allowed', description: 'The sender did not launch the run.' },
  { reason: 'run_not_live', description: 'The run is not running on any host.' },
  { reason: 'host_not_connected', description: 'The host that runs the run is not connected to the relay.' },
  { reason: 'runner_not_connected', description: 'The host is connected, but the runner that runs the run is not.' },
  { reason: 'message_too_large', description: 'The message is over the text cap or the relay frame limit.' },
  { reason: 'channel_full', description: 'The relay could not queue the frame to the host.' },
  { reason: 'inbox_full', description: 'The run already holds as many messages as it keeps for its next turn.' },
  { reason: 'mode_does_not_accept', description: 'The run does not take messages while it works: a workflow run.' },
  { reason: 'duplicate', description: 'The run already has a message with this message_id.' },
  { reason: 'unknown_message_type', description: 'The receiver does not know the frame type.' },
  { reason: 'run_ended_before_delivery', description: 'The run ended before its next turn.' },
]

/** Why the runner forced a workflow task step to finish; the step completed with valid outputs (Go: missionstream.ForcedReason). */
export type ForcedReason = 'budget' | 'stuck_repeating' | 'repeated_failure' | 'schema_churn'

/** One row of the forced-reason table: a reason and what it means. */
export type ForcedReasonRow = { readonly forced_reason: ForcedReason; readonly description: string }

/** Every forced reason, in the table's order (Go: missionstream.ForcedReasons). */
export const ForcedReasons: readonly ForcedReasonRow[] = [
  { forced_reason: 'budget', description: 'The run used every turn.' },
  { forced_reason: 'stuck_repeating', description: 'The model repeated earlier calls with the same arguments and got the same results.' },
  { forced_reason: 'repeated_failure', description: 'The same tool failed with the same error class several times in a row.' },
  { forced_reason: 'schema_churn', description: 'The same schema failure kept recurring against the same target.' },
]

/** Each forced reason's uppercase Problem Code and the wire name it reads as, the one lowercase mapping (Go: missionstream.LegacyForcedReasons). */
export const ForcedReasonByCode: Readonly<Record<string, ForcedReason>> = {
  BUDGET: 'budget',
  STUCK_REPEATING: 'stuck_repeating',
  REPEATED_FAILURE: 'repeated_failure',
  SCHEMA_CHURN: 'schema_churn',
}

/** The longest text one user message carries, in UTF-8 bytes (Go: missionstream.MaxUserMessageTextBytes). */
export const MaxUserMessageTextBytes = 65536

/** The longest text one operator reply carries, in characters (Go: missionstream.MaxOperatorMessageChars). */
export const MaxOperatorMessageChars = 4000

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixMessage). */
export const RequestIDPrefixMessage = 'msg-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixPreamble). */
export const RequestIDPrefixPreamble = 'preamble-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixOutput). */
export const RequestIDPrefixOutput = 'output-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixFeedback). */
export const RequestIDPrefixFeedback = 'feedback-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixNudge). */
export const RequestIDPrefixNudge = 'nudge-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixResult). */
export const RequestIDPrefixResult = 'result-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixTell). */
export const RequestIDPrefixTell = 'tell-'

/** A chat frame's request id starts with this prefix (Go RequestIDPrefixFinal). */
export const RequestIDPrefixFinal = 'final-'

/** A HITL request's modality (Go: missionstream.HITLModality* constants). */
export type HITLModality = 'approval' | 'escalation' | 'message' | 'question' | 'text'

/** Every HITL modality the runners send (Go: missionstream.HITLModalities). */
export const HITLModalities: readonly HITLModality[] = ['approval', 'escalation', 'message', 'question', 'text']
